import {
  combineReducers
} from 'redux'
import {
  OTOP,
  POPULAR_OTOP,
  OTOP_DETAILS,
  OTOP_ADD_TO_CART,
  OTOP_REMOVE_FROM_CART,
  OTOP_CHECKOUT
} from '../../actions/actionTypes'
import {
  fetchingData,
  initStateLang
} from '../../utils'

const initailState = {
  loading: false,
  error: '',
  data: [],
  lastUpdate: ''
}

const list = (state = initStateLang(initailState, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case OTOP.REQUEST:
    return {
      ...state,
      loading: true,
      error: '',
    }
  case OTOP.SUCCESS:
    return {
      ...state,
      loading: false,
      error: '',
      [action.lang]: { data: action.data, lastUpdate: action.lasted }
    }
  case OTOP.FAILURE:
    return {
      ...state,
      loading: false,
      error: action.error,
    }
  default:
    return state
  }
}
const popular = (state = initStateLang(initailState, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case POPULAR_OTOP.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      }
    case POPULAR_OTOP.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted }
      }
    case POPULAR_OTOP.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
const initailStateDetail = {
  loading: false,
  error: '',
  data: {},
  lastUpdate: ''
}
const details = (state = initStateLang(initailStateDetail, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case OTOP_DETAILS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        [action.lang]: { data: {} }
      }
    case OTOP_DETAILS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted }
      }
    case OTOP_DETAILS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
const initailStateCart = {
  loading: false,
  sendSuccess: false,
  error: '',
  cart: [],
  data: {}
}


const cart = (state = initailStateCart, action) => {
  switch (action.type) {
    case OTOP_ADD_TO_CART:
      return {
        ...state,
        cart: (
          !state.cart.some(value => action.id === value.id)
          ? [...state.cart, { id: action.id, qty: 1 }]
          : state.cart.map(value => {
            if (action.id === value.id) {
              return { ...value, qty: value.qty + 1 }
            }
            return value
          })
        )
      }
    case OTOP_REMOVE_FROM_CART:
      return {
        ...state,
        cart: (
          !state.cart.some(value => action.id === value.id)
          ? state.cart
          : state.cart.reduce((prev, cur) => {
            if (action.id === cur.id) {
              if (cur.qty - 1 === 0) {
                return prev
              }
              return [...prev, { ...cur, qty: cur.qty - 1 }]
            }
            return [...prev, cur]
          }, [])
        )
      }
    case OTOP_CHECKOUT.REQUEST:
      return {
        ...state,
        loading: true,
        sendSuccess: false,
        error: '',
      }
    case OTOP_CHECKOUT.SUCCESS:
      return {
        ...state,
        loading: false,
        sendSuccess: true,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted },
        cart: []
      }
    case OTOP_CHECKOUT.FAILURE:
      return {
        ...state,
        loading: false,
        sendSuccess: false,
        error: action.error,
      }
    default:
      return state
  }
}
export default combineReducers({
  list,
  popular,
  details,
  cart
})



// WEBPACK FOOTER //
// ./src/containers/Otop/reducer.js